import { render, staticRenderFns } from "./LongTermSearch.vue?vue&type=template&id=fe95ef52&scoped=true&"
import script from "./LongTermSearch.vue?vue&type=script&lang=js&"
export * from "./LongTermSearch.vue?vue&type=script&lang=js&"
import style0 from "./LongTermSearch.vue?vue&type=style&index=0&id=fe95ef52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe95ef52",
  null
  
)

export default component.exports